var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "transcript-summary-panel" },
    [
      _vm.isCompleted
        ? _c(
            "div",
            [
              _vm.resumoText
                ? _c(
                    "TranscriptSummaryCard",
                    { attrs: { title: "Resumo", inverted: _vm.inverted } },
                    [
                      _c(
                        "p",
                        { staticClass: "az-text-primary az-size-14 mb-0" },
                        [_vm._v(_vm._s(_vm.resumoText))]
                      )
                    ]
                  )
                : _vm._e(),
              _vm.decisions.length
                ? _c(
                    "TranscriptSummaryCard",
                    { attrs: { title: "Decisões", inverted: _vm.inverted } },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-column az-gap-small" },
                        _vm._l(_vm.decisions, function(decision, i) {
                          return _c("TranscriptSummaryItem", {
                            key: i,
                            attrs: {
                              icon: "mdi-gavel",
                              text: _vm.itemText(decision),
                              inverted: _vm.inverted
                            }
                          })
                        }),
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm.nextSteps.length
                ? _c(
                    "TranscriptSummaryCard",
                    {
                      attrs: {
                        title: "Próximos passos",
                        inverted: _vm.inverted
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-column az-gap-small" },
                        _vm._l(_vm.nextSteps, function(step, i) {
                          return _c("TranscriptSummaryItem", {
                            key: i,
                            attrs: {
                              icon: "check-circle",
                              "icon-color": "success",
                              text: _vm.itemText(step),
                              inverted: _vm.inverted
                            },
                            scopedSlots: _vm._u(
                              [
                                _vm.itemResponsavel(step)
                                  ? {
                                      key: "right",
                                      fn: function() {
                                        return [
                                          _c(
                                            "v-chip",
                                            {
                                              attrs: {
                                                "x-small": "",
                                                color: "#E8EAF1",
                                                "text-color": "#5B5B5B"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.itemResponsavel(step)
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  : null
                              ],
                              null,
                              true
                            )
                          })
                        }),
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm.opportunities.length
                ? _c(
                    "TranscriptSummaryCard",
                    {
                      attrs: {
                        title: "Oportunidades identificadas",
                        inverted: _vm.inverted
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-column az-gap-small" },
                        _vm._l(_vm.opportunities, function(opp, i) {
                          return _c("TranscriptSummaryItem", {
                            key: i,
                            attrs: {
                              icon: "lamp-on",
                              "icon-color": "warning-new",
                              text: _vm.itemText(opp),
                              inverted: _vm.inverted
                            }
                          })
                        }),
                        1
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _c(
            "TranscriptStateFeedback",
            _vm._b(
              {
                scopedSlots: _vm._u(
                  [
                    _vm.isPendingEnded
                      ? {
                          key: "button",
                          fn: function() {
                            return [
                              _c(
                                "BaseButton",
                                {
                                  attrs: {
                                    sm: "",
                                    fitContent: "",
                                    primary: ""
                                  },
                                  on: { click: _vm.onRegenerate }
                                },
                                [_vm._v(" Gerar resumo ")]
                              )
                            ]
                          },
                          proxy: true
                        }
                      : null
                  ],
                  null,
                  true
                )
              },
              "TranscriptStateFeedback",
              _vm.feedback,
              false
            )
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }